import usePQStore from "@/stores/price-quotes.store";
import useProfileStore from "@/stores/profile.store";
import { getStatus } from "@/shared/helpers/price-quotes/getStatusPQ";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { STATUSORDER } from "@/shared/utils/enums/statusOrder";
import { hasRoles } from "../useRolePermissions";

export function usePQRouter () {
    const store = usePQStore();
    const { pq } = storeToRefs(store);
    
    const statusReturned = computed( () => {
        return getStatus(pq.value) === STATUSORDER.PedidoDevuelto
    })

    return {
        statusReturned
    }
}